import React, { FC, MouseEventHandler } from 'react';
import { useTranslation } from 'react-i18next';
import { ITrajectoryDetail } from '../../../../../config/api/models/Trajectory';
import { Button, Icons, Paragraph } from '../../../../shared/components';
import { useUser } from '../../../../shared/hooks';
import { styled } from '@material-ui/core';
import { DifferentiationsOverviewWrapper } from '../../Differentiation/Atoms';

type Props = {
  trajectory: ITrajectoryDetail;
  pageId?: string;
  onPublish?: (id: string, title: string) => void;
  onUnPublish?: (id: string, title: string) => void;
};

const PublishButtonWrapper = styled('div')({
  paddingBottom: '3rem',
});

export const TrajectoryPublishSidebar: FC<Props> = ({
  pageId,
  trajectory,
  onPublish,
  onUnPublish,
}) => {
  const { t } = useTranslation();
  const { isAuthor } = useUser();

  return pageId != null ? (
    <DifferentiationsOverviewWrapper>
      <Paragraph>Still no description</Paragraph>
      {!!trajectory && isAuthor && (
        <PublishButtonWrapper>
          {trajectory.isDraft ? (
            <Button
              icon={Icons.PUBLISH_DRAFT}
              onClick={onPublish as unknown as MouseEventHandler<HTMLButtonElement>}
            >
              {t('books.chapter.trajectories.publish')}
            </Button>
          ) : (
            <Button
              icon={Icons.UN_PUBLISH_DRAFT}
              onClick={onUnPublish as unknown as MouseEventHandler<HTMLButtonElement>}
            >
              {t('books.chapter.trajectories.unPublish')}
            </Button>
          )}
        </PublishButtonWrapper>
      )}
    </DifferentiationsOverviewWrapper>
  ) : null;
};
